import { mixed, object } from 'yup';

export const deliveriesListSearchValidation = object().shape({
  fromDate: mixed().test('check fromDate value', function (value) {
    const toCreatedDate = this.parent.toDate;
    if (!value || !toCreatedDate) return true;

    return new Date(value) > new Date(toCreatedDate)
      ? this.createError({
          message: 'טווח התאריכים שגוי',
          path: 'fromDate',
        })
      : true;
  }),
  toDate: mixed().test('check toDate value', function (value) {
    const fromCreatedDate = this.parent.fromDate;
    if (!value || !fromCreatedDate) return true;

    if (fromCreatedDate) {
      return new Date(value) < new Date(fromCreatedDate)
        ? this.createError({
            message: 'טווח התאריכים שגוי',
            path: 'toDate',
          })
        : true;
    }

    return true;
  }),
});
